import { render } from "./zyjReviewDetail.vue?vue&type=template&id=2d2df378&scoped=true"
import script from "./zyjReviewDetail.vue?vue&type=script&lang=js"
export * from "./zyjReviewDetail.vue?vue&type=script&lang=js"

import "./zyjReviewDetail.vue?vue&type=style&index=0&id=2d2df378&lang=sass&scoped=true"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2df378"]])

export default __exports__